module.exports = __webpack_public_path__ + "img/kcn.b821ad4d.jpg";